import { render, staticRenderFns } from "./checkManageMentDetail.vue?vue&type=template&id=3c0feba0&scoped=true&"
import script from "./checkManageMentDetail.vue?vue&type=script&lang=js&"
export * from "./checkManageMentDetail.vue?vue&type=script&lang=js&"
import style0 from "./checkManageMentDetail.vue?vue&type=style&index=0&id=3c0feba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0feba0",
  null
  
)

export default component.exports